import React from "react";
import {
  ResponsiveContainer,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  Legend,
  Area,
  AreaChart,
} from "recharts";

/**
 * LineChartBI - Wrapper de Recharts para tendencias de ventas mensuales (24 meses).
 *
 * Props:
 * - data: Array de { mes: string, ventas: number }
 * - title: string (opcional)
 * - height: number (opcional, default 300)
 */
export function LineChartBI({ data = [], title, height = 300 }) {
  const formatColones = (value) => {
    if (value >= 1000000) {
      return `₡${(value / 1000000).toFixed(1)}M`;
    }
    if (value >= 1000) {
      return `₡${(value / 1000).toFixed(0)}K`;
    }
    return `₡${value}`;
  };

  const tooltipFormatter = (value) => {
    return `₡${Number(value).toLocaleString("es-CR")}`;
  };

  return (
    <div className="bg-white rounded-lg shadow-sm border border-gray-200 p-4">
      {title && (
        <p className="font-semibold text-gray-700 mb-4">{title}</p>
      )}
      <ResponsiveContainer width="100%" height={height}>
        <AreaChart
          data={data}
          margin={{ top: 5, right: 30, left: 20, bottom: 5 }}
        >
          <defs>
            <linearGradient id="colorVentas" x1="0" y1="0" x2="0" y2="1">
              <stop offset="5%" stopColor="#3B82F6" stopOpacity={0.3} />
              <stop offset="95%" stopColor="#3B82F6" stopOpacity={0.05} />
            </linearGradient>
          </defs>
          <CartesianGrid strokeDasharray="3 3" stroke="#E5E7EB" />
          <XAxis
            dataKey="mes"
            tick={{ fontSize: 12, fill: "#6B7280" }}
            tickLine={false}
            axisLine={{ stroke: "#E5E7EB" }}
          />
          <YAxis
            tickFormatter={formatColones}
            tick={{ fontSize: 12, fill: "#6B7280" }}
            tickLine={false}
            axisLine={{ stroke: "#E5E7EB" }}
            width={70}
          />
          <Tooltip
            formatter={tooltipFormatter}
            labelStyle={{ color: "#374151", fontWeight: 600 }}
            contentStyle={{
              borderRadius: "8px",
              border: "1px solid #E5E7EB",
              boxShadow: "0 2px 4px rgba(0,0,0,0.1)",
            }}
          />
          <Legend
            wrapperStyle={{ fontSize: "12px", color: "#6B7280" }}
          />
          <Area
            type="monotone"
            dataKey="ventas"
            name="Ventas"
            stroke="#3B82F6"
            strokeWidth={2}
            fill="url(#colorVentas)"
            dot={{ r: 3, fill: "#3B82F6" }}
            activeDot={{ r: 5, fill: "#2563EB" }}
          />
        </AreaChart>
      </ResponsiveContainer>
    </div>
  );
}

export default LineChartBI;
